<template>
     <div class="loader">
        <lottie-animation
                path="loading.json"
            />
    </div>
</template>
<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
    components:{
        LottieAnimation
    }
};
</script>
<style>
.loader{
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
 
}
</style>